const _require = require('@truqc/content-path'),
  getValue = _require.getValue;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate equalsBehavior
  */
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.source, content, parentContentPath, transientContext, nativeFunctions);
  if (!Array.isArray(values)) {
    return undefined;
  }
  const compareValue = await evaluateSource(source.compareValue, content, parentContentPath, transientContext, nativeFunctions);
  if (compareValue === undefined) {
    return undefined;
  }
  const comparePath = await evaluateSource(source.comparePath, content, parentContentPath, transientContext, nativeFunctions);
  return values.filter(element => {
    const value = comparePath ? getValue(comparePath, element) : element;
    return value === compareValue ? value : undefined;
  });
};
module.exports = {
  evaluate
};